var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-group',{attrs:{"invalid-feedback":_vm.errorTxt,"state":_vm.state}},[_c('b-input-group',{attrs:{"prepend":_vm.label?_vm.label:_vm.$t('group')}},[_c('b-form-select',{attrs:{"options":_vm.options,"state":_vm.state,"disabled":_vm.disabled},model:{value:(_vm.inputVal),callback:function ($$v) {_vm.inputVal=$$v},expression:"inputVal"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }